import { VerticalContainer } from '@/components/containers/VerticalContainer';
import classNames from 'classnames';
import React from 'react';
import AttachmentIcon from '@/../wwwroot/images/icons/attachment-clip-icon.svg?react';
import { R } from '@/Resources.resx';

type UploadFilesButtonProps = {
    className?: string;
    accept?: string;
    onFileChange: any;
};

export const UploadFilesButton = ({
    className,
    accept,
    onFileChange,
}: UploadFilesButtonProps) => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    return (
        <VerticalContainer className={classNames('w-full', className)}>
            <input
                ref={inputRef}
                type="file"
                multiple={true}
                onChange={onFileChange}
                hidden={true}
                accept={accept}
            />
            <button
                className={'btn btn-ghost inline-flex w-fit gap-4 self-end'}
                onClick={(e) => {
                    inputRef.current.click();
                    e.preventDefault();
                }}
            >
                <AttachmentIcon />
                {R.AddFile}
            </button>
        </VerticalContainer>
    );
};
